module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1178.da1c6333.png";